export const modalityOptions = [
  { label: "-- Select --", value: "none", disabled: false, italic: true },
  { label: "Individual", value: "Individual" },
  { label: "Couple", value: "Couple" },
  { label: "Minor", value: "Minor" },
  { label: "Group", value: "Group" },
];
